"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    combinePredicates: function() {
        return combinePredicates;
    },
    evaluatePredicate: function() {
        return evaluatePredicate;
    }
});
const _promises = require("./promises");
function combinePredicates(predicates, operand) {
    return async (...args)=>{
        if (operand === 'AND') {
            for (const predicate of predicates){
                if (await (0, _promises.asPromise)(predicate(...args)) === false) return false;
            }
            return true;
        } else {
            for (const predicate of predicates){
                if (await (0, _promises.asPromise)(predicate(...args)) === true) return true;
            }
            return false;
        }
    };
}
function evaluatePredicate(items, predicate, operand = 'OR') {
    const out = items.reduce((prev, item)=>{
        if (operand === 'AND' && prev === false || operand === 'OR' && prev === true) {
            return prev;
        }
        return predicate(item);
    }, undefined);
    return out;
}

//# sourceMappingURL=predicates.js.map